import { useEffect, useState } from "react";
import { ChevronDown, Printer } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { api, apiError } from "@/lib/api";

// "Yazdır ▾": siparişe uygun aktif şablonlar, belge türüne göre gruplu; varsayılan önce. Seçim → sayaç kaydı + baskı sayfası (yeni sekme).
export default function PrintMenu({ order, onCounts, extra = [] }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/orders/${order.id}/print-templates`).then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, [order.id, order.status]);
  const go = async (t) => {
    const w = window.open("", "_blank");
    try {
      const { data } = await api.post(`/orders/${order.id}/print`, { doc: t.doc_type, template_id: t.id });
      onCounts?.(data);
      if (w) w.location.href = `/siparisler/${order.id}/yazdir/t/${t.id}`;
    } catch (e) { w?.close(); toast.error(apiError(e)); }
  };
  const groups = (items || []).reduce((g, t) => ({ ...g, [t.doc_type_name]: [...(g[t.doc_type_name] || []), t] }), {});
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild><Button size="sm" className="bg-slate-900 hover:bg-slate-800" data-testid="print-menu-button"><Printer className="h-4 w-4 mr-1" />Yazdır<ChevronDown className="h-3.5 w-3.5 ml-1" /></Button></DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72" data-testid="print-menu">
        {items === null && <DropdownMenuLabel className="text-xs text-slate-400">Yükleniyor…</DropdownMenuLabel>}
        {Object.entries(groups).map(([g, ts], gi) => (
          <div key={g}>{gi > 0 && <DropdownMenuSeparator />}
            <DropdownMenuLabel className="text-[11px] uppercase tracking-wide text-slate-400">{g}</DropdownMenuLabel>
            {ts.map((t) => <DropdownMenuItem key={t.id} onClick={() => go(t)} data-testid={`print-menu-item-${t.id}`}>{t.name}{t.is_default && <span className="ml-auto text-[10px] text-emerald-700">(Varsayılan)</span>}</DropdownMenuItem>)}
          </div>))}
        {extra.length > 0 && <><DropdownMenuSeparator /><DropdownMenuLabel className="text-[11px] uppercase tracking-wide text-slate-400">Diğer</DropdownMenuLabel>
          {extra.map((x) => <DropdownMenuItem key={x.key} onClick={x.onClick} data-testid={`print-menu-extra-${x.key}`}>{x.label}</DropdownMenuItem>)}</>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
